import Axios from 'axios'
import {
	ICrudApplyCustomerAttrFilters,
	ICrudApplyCustomerAttrIndividual,
	ICrudCustomerAttrGlobalAssign,
	ICrudCustomerAttrGlobalAssignConfirm,
	ICrudCustomerAttrGlobalAssignEdit,
	ICrudCustomerAttrGlobalAssignPaginate
} from 'models/CustomerGlobalUploadInterface'

export const customerAttrGlobalApply = async (
	params: ICrudApplyCustomerAttrFilters
) => {
	const response = await Axios.post(
		`conf_atrib_global_cliente/seleccionar`,
		params
	)
	return response.data
}

export const customerAttrIndividualApply = async (
	params: ICrudApplyCustomerAttrIndividual
) => {
	const response = await Axios.post(
		`Conf_atrib_global_cliente/editar/confirmar `,
		params
	)
	return response.data
}
export const customerAttrGlobalAssign = async (
	params: ICrudCustomerAttrGlobalAssign
) => {
	const response = await Axios.post(
		`Conf_atrib_global_cliente/asignaGlobal `,
		params
	)
	return response.data
}
export const customerAttrGlobalAssignConfirm = async (
	params: ICrudCustomerAttrGlobalAssignConfirm
) => {
	const response = await Axios.post(
		`Conf_atrib_global_cliente/confirmar `,
		params
	)
	return response.data
}

export const customerAttrGlobalAssignEdit = async (
	params: ICrudCustomerAttrGlobalAssignEdit
) => {
	const response = await Axios.get(
		`Conf_atrib_global_cliente/editar?idOperacion=${params.idOperacion}&niclie=${params.niclie}`
	)
	return response.data
}
export const customerAttrGlobalAssignPaginate = async (
	params: ICrudCustomerAttrGlobalAssignPaginate
) => {
	const response = await Axios.post(
		`Conf_atrib_global_cliente/paginar `,
		params
	)
	return response.data
}
